// frontend/src/components/ProtectedRoute.tsx
import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
// import { jwtDecode } from 'jwt-decode'; // npm install jwt-decode
// import { type DecodedTokenPayload } from '@/types'; // Assuming you have this



const ProtectedRoute: React.FC<{ adminOnly?: boolean }> = () => {
  const location = useLocation();
  const token = localStorage.getItem('authToken');
  let isAuthenticated = false;

  if (token) {
    try {
      // const decodedToken = jwtDecode<DecodedTokenPayload>(token);
      // const currentTime = Date.now() / 1000;
      // if (decodedToken.exp > currentTime) {
      //   isAuthenticated = true;
      //   userRole = decodedToken.role;
      // } else {
      //   localStorage.removeItem('authToken'); // Token expired
      // }
      
      // Simplified check for now - assumes token presence means authenticated
      // For production, proper token validation (expiry, signature if possible on client) is crucial
      // Or, better yet, make a quick API call to a /auth/me endpoint to verify token on server
      isAuthenticated = true; 
      
      // Attempt to get role if stored separately, or decode from token (as above)
      // For this example, let's assume role is needed for adminOnly and would be in token
      // For simplicity, we'll hardcode for now or assume it's fetched/decoded elsewhere.
      // This part needs robust implementation based on how you store/access role.
      // For now, let's simulate fetching it or directly check if admin for demo:
      // userRole = localStorage.getItem('userRole'); // If you store role separately on login
      // For actual decoding:
      // const decoded = jwtDecode<DecodedTokenPayload>(token); userRole = decoded.role;

    } catch (e) {
      console.error("Error decoding token:", e);
      localStorage.removeItem('authToken'); // Invalid token
    }
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // This is a simplified role check. In a real app, userRole would come from the decoded token.
  // For now, let's assume if adminOnly is true, we'd have a way to check role.
  // As current_user.role == UserRole.ADMIN.value is checked on backend,
  // the primary client-side concern is redirecting non-logged-in users.
  // The fine-grained role check for specific actions will be enforced by the API.
  // However, for UI hiding/showing or client-side route protection for roles:
  // if (adminOnly && userRole !== 'admin') {
  //   return <Navigate to="/unauthorized" replace />; // Or back to dashboard, or home
  // }

  return <Outlet />;
};

export default ProtectedRoute;